import React from 'react';
import type { FormInstance } from 'antd';
import { Form, InputNumber, Popover, Select } from 'antd';
import MenuUnfoldOutlined from '@ant-design/icons/MenuUnfoldOutlined';
import MenuFoldOutlined from '@ant-design/icons/MenuFoldOutlined';
import ColumnHeightOutlined from '@ant-design/icons/ColumnHeightOutlined';
import { RibbonIconButton } from '../bookDefaultStyles/WordStyleRibbon';
import { styleFieldName } from '../../utils/styleFormFieldNames';
import { LINE_HEIGHT_OPTIONS } from './styleEditorConstants';
import { RibbonControlHint } from './RibbonControlHint';

const INDENT_STEP = 24;

type Props = {
  form: FormInstance;
  namePrefix?: string | string[];
};

export const ParagraphPositionControls: React.FC<Props> = ({ form, namePrefix }) => {
  const indentField = styleFieldName(namePrefix, 'textIndent');
  const indent = Form.useWatch(indentField, form) ?? 0;
  const lineHeightField = styleFieldName(namePrefix, 'lineHeight');
  const lineHeight = Form.useWatch(lineHeightField, form) ?? 1;

  const adjustIndent = (delta: number) => {
    const next = Math.max(-240, Math.min(240, Number(indent || 0) + delta));
    form.setFieldValue(indentField, next === 0 ? 0 : next);
  };

  return (
    <div className="word-ribbon-inline">
      <RibbonIconButton title="Decrease indent" onClick={() => adjustIndent(-INDENT_STEP)}>
        <MenuFoldOutlined />
      </RibbonIconButton>
      <RibbonIconButton title="Increase indent" onClick={() => adjustIndent(INDENT_STEP)}>
        <MenuUnfoldOutlined />
      </RibbonIconButton>
      <Popover
        trigger="click"
        getPopupContainer={() => document.body}
        placement="bottom"
        title="Line spacing"
        content={
          <div style={{ padding: 4 }}>
            <div style={{ fontSize: 12, marginBottom: 6 }}>Line height</div>
            <Select
              size="small"
              style={{ width: 120 }}
              value={lineHeight}
              options={LINE_HEIGHT_OPTIONS}
              onChange={(v) => form.setFieldValue(lineHeightField, v)}
            />
          </div>
        }
      >
        <span>
          <RibbonIconButton title="Line height">
            <ColumnHeightOutlined />
          </RibbonIconButton>
        </span>
      </Popover>
      <RibbonControlHint title="Text indent (px) — positive indents, negative outdents">
        <Form.Item name={indentField} initialValue={0} noStyle>
          <InputNumber
            size="small"
            min={-240}
            max={240}
            step={INDENT_STEP}
            className="word-ribbon-compact-input"
            style={{ width: 56 }}
            placeholder="Ind"
          />
        </Form.Item>
      </RibbonControlHint>
    </div>
  );
};
